"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.excludeDates = void 0;
const lodash_1 = __importDefault(require("lodash"));
/**
 * Returns a filtered list of dates that do not occur in the date exclusions list
 */
const excludeDates = ({ dates, exclusions, }) => {
    return lodash_1.default.difference(dates, exclusions);
};
exports.excludeDates = excludeDates;
//# sourceMappingURL=exclusion.js.map